import { Link, useLocation } from 'react-router-dom';

const Pagination = ({ pages, params = 'page' }) => {
    const { page, size, totalRow } = pages;
    const totalPage = Math.ceil(totalRow / size);
    const { pathname, search } = useLocation();
    const currentBlock = Math.ceil(page / 10);
    const totalBlocks = Math.ceil(totalPage / 10);

    const formatUrl = (pageNumber) => {
        const searchParams = new URLSearchParams(search);
        searchParams.set(params, pageNumber);
        return `${pathname}?${searchParams.toString()}`;
    };

    const renderPagesHTML = (pageSize = 10) => {
        const listPage = [];
        const currentBlock = Math.ceil(page / pageSize);
        const startPage = (currentBlock - 1) * pageSize + 1;
        const endPage = Math.min(currentBlock * pageSize, totalPage);

        for (let i = startPage; i <= endPage; i++) {
            listPage.push(i);
        }

        return listPage;
    };

    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div className="wrap-pagination">
            {currentBlock > 1 && (
                <Link
                    to={formatUrl(Math.floor((page - 1) / 10) * 10)}
                    className="pagination-arrow icon icon-prev"
                    onClick={handleScrollToTop}
                ></Link>
            )}
            <ul className="pagination-number">
                {totalPage > 1 &&
                    renderPagesHTML().map((pageNumber, index) => (
                        <li key={index} className={pageNumber === page ? 'active' : ''}>
                            <Link to={formatUrl(pageNumber)} onClick={handleScrollToTop}>
                                {pageNumber}
                            </Link>
                        </li>
                    ))}
            </ul>
            {currentBlock < totalBlocks && (
                <Link
                    to={formatUrl(currentBlock * 10 + 1)}
                    className="pagination-arrow icon icon-next" onClick={handleScrollToTop}
                ></Link>
            )}
        </div>
    );
};

export default Pagination;
